<app-si-dialog #dialog saveButtonText="Yes" [hideHeader]="true" modalFooterClasses="si-dialog__footer--centered" (save)="dialog.onClose(true)">
  <ng-template appDialogBody>
    <div class="px-16 py-6">
      <div class="flex items-center gap-5">
        <fa-icon class="text-danger shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
        <p class="m-0">Do you really want to delete the buyer persona group?</p>
      </div>
    </div>
  </ng-template>
</app-si-dialog>
